import { z } from "zod";

const zIn = z.object({
  file: z.instanceof(File),
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
